import { render, staticRenderFns } from "./files-view.vue?vue&type=template&id=c16a1634&"
import script from "./files-view.vue?vue&type=script&lang=js&"
export * from "./files-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports